import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { colors } from '../../../lib/colors';
import WeeklyTimeCell from './WeeklyTimeCell';
import ScheduleBlock from './BlockItem/ScheduleBlock';
import EtcScheduleBlock from './BlockItem/EtcScheduleBlock';
import GroupScheduleBlock from './BlockItem/GroupScheduleBlock';
import GroupSessionWeeklyBlock from './BlockItem/GroupSessionWeeklyBlock';
import NewOpportunityBlock from './BlockItem/NewOpportunityBlock';
import RequestBlock from './BlockItem/RequestBlock';
import { getLegacyWeeklyRowHeight, LEGACY_WEEKLY_HEADER_HEIGHT } from './layout';

const WeekScheduleTable = ({
    weeklyScheduleList,
    weeklyGridData,
    lengthArr,
    selectedDay,
    scrollY,
    onClickSchedule,
    onClickRequest,
    onClickEtcOffSchedule,
    onClickNewOpportunity,
    onClickApproveScheduleRequest,
    onClickRejectScheduleRequest,
}: any) => {
    return (
        <Col
            style={{
                width: '100%',
                marginTop: LEGACY_WEEKLY_HEADER_HEIGHT + 4,
                backgroundColor: colors.WHITE_200,
                position: 'relative',
            }}
        >
            {weeklyGridData &&
                weeklyGridData.map((row: any, rowIndex: number) => {
                    const rowLengths = Array.isArray(lengthArr?.[rowIndex])
                        ? lengthArr[rowIndex].map((value: number | null) => value ?? 0)
                        : [];
                    const rowHeightCount = rowLengths.length > 0 ? Math.max(...rowLengths) : 0;

                    return (
                        <React.Fragment key={rowIndex + 'weekGridData'}>
                            <Row>
                                {row.map((cell: any, cellIndex: number) => {
                                    // row에서 첫번째 열일 때
                                    if (cellIndex === 0) {
                                        return (
                                            // 주간 달력 좌측 시간 표시
                                            <WeeklyTimeCell
                                                key={cell.id}
                                                lengthArr={lengthArr}
                                                rowIndex={rowIndex}
                                                cell={cell}
                                            />
                                        );
                                    }
                                    // row에서 날짜 밑에있는 열들일때
                                    else {
                                        const cellSchedules = Array.isArray(cell) ? cell : [];
                                        // startTime을 기준으로 객체들을 묶어서 Map을 만듬.
                                        const cellSchedulesWithDuoMap = cellSchedules.reduce((acc: any, obj: any) => {
                                            const key = obj.coachId + '-' + obj.type + obj.startTime;

                                            if (!acc.has(key)) {
                                                acc.set(key, []);
                                            }
                                            acc.get(key).push(obj);

                                            return acc;
                                        }, new Map());

                                        // 중복되지 않은 요소들과 함께 배열로 만듬.
                                        const cellSchedulesWithDuo = Array.from(cellSchedulesWithDuoMap.values());

                                        return (
                                            // 주간 달력 표 내용

                                            // 표 레이아웃 그리기
                                            <Col
                                                style={{
                                                    width: '13.28%',
                                                    height: getLegacyWeeklyRowHeight(rowHeightCount),
                                                    boxShadow: cellIndex === 0 ? '' : '0 0 0 0.1px black',
                                                    alignItems: 'center',
                                                    paddingTop: 2,
                                                    // paddingBottom: 4,
                                                }}
                                            >
                                                {cellSchedulesWithDuo &&
                                                    cellSchedulesWithDuo.map((childArr: any, childIndex: number) => {
                                                        const childItem = childArr[0];

                                                        const isGroupSession =
                                                            childItem.classType &&
                                                            childItem.classType !== 'PRIVATE_1ON1';
                                                        return childItem.type === 'schedule' ? (
                                                            isGroupSession ? (
                                                                <GroupSessionWeeklyBlock
                                                                    key={childIndex + 'weeklyGroupSession' + rowIndex}
                                                                    cellIndex={cellIndex}
                                                                    childItem={childItem}
                                                                    onClickSchedule={onClickSchedule}
                                                                />
                                                            ) : childArr.length === 1 ? (
                                                                <ScheduleBlock
                                                                    key={childIndex + 'weeklySchedule' + rowIndex}
                                                                    cellIndex={cellIndex}
                                                                    childItem={childItem}
                                                                    onClickSchedule={onClickSchedule}
                                                                />
                                                            ) : (
                                                                <GroupScheduleBlock
                                                                    key={childIndex + 'groupScheduleBox'}
                                                                    cellIndex={cellIndex}
                                                                    childArr={childArr}
                                                                    onClickSchedule={onClickSchedule}
                                                                />
                                                            )
                                                        ) : childItem.type === 'onetimeSchedule' ? (
                                                            <EtcScheduleBlock
                                                                key={childIndex + 'weeklyEtcSchedule' + rowIndex}
                                                                cellIndex={cellIndex}
                                                                childItem={childItem}
                                                                onClickEtcOffSchedule={onClickEtcOffSchedule}
                                                            />
                                                        ) : childItem.type === 'newOpportunity' ? (
                                                            <NewOpportunityBlock
                                                                key={childIndex + 'weeklyNewOpportunity' + rowIndex}
                                                                cellIndex={cellIndex}
                                                                childItem={childItem}
                                                                onClickNewOpportunity={onClickNewOpportunity}
                                                            />
                                                        ) : childItem.type === 'request' ? (
                                                            <RequestBlock
                                                                key={childIndex + 'weeklyEtcSchedule' + rowIndex}
                                                                cellIndex={cellIndex}
                                                                childItem={childItem}
                                                                onClickRequest={onClickRequest}
                                                                onClickApproveScheduleRequest={
                                                                    onClickApproveScheduleRequest
                                                                }
                                                                onClickRejectScheduleRequest={
                                                                    onClickRejectScheduleRequest
                                                                }
                                                            />
                                                        ) : null;
                                                    })}
                                            </Col>
                                        );
                                    }
                                })}
                            </Row>
                        </React.Fragment>
                    );
                })}
        </Col>
    );
};

export default WeekScheduleTable;
